import { Button, Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ECapReportStepProps } from ".";
import { VALIDATION_MESSAGE_CONFIG } from "../../../../constants/constants";
import AmountInput from "../../../atoms/amount-input";
import PercentInput from "../../../atoms/percent-input";

const planingCycleYears = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    return [currentYear - 1, currentYear - 2, currentYear - 3];
}

const years = planingCycleYears(); 


const ORInput = (props: ECapReportStepProps) => {

    const { t } = useTranslation();

    const formSubmit = (v: any) => {
        const alpha = v.alpha / 100;

        const data = years.map((year) =>  ({
            year,
            value: v[year]?.value
        }))
        const values: any = {
            alpha,
            net_interest_incomes: data
        }
        if (props.next) {
            props.next(values);
        }
    }

    return (
        <div className="step-content-item-wrapper">

            <div className="step-content-item-header">
                <h4>
                    {t("EcapModule.lbTitleInput")}
                </h4>
            </div>

            <Form
                layout='vertical'
                validateMessages={VALIDATION_MESSAGE_CONFIG}
                onFinish={(values) => formSubmit(values)}
                initialValues={{ net_interest_incomes: [{}] }}
                scrollToFirstError>
                <Form.Item
                    label={t("EcapModule.lbAlpha")}
                    name="alpha"
                    rules={[{ required: true }]}>
                    <PercentInput />
                </Form.Item>

                <div className="or-form-list">
                    <div> 
                        {years?.length && years.map((year) => (
                            <Form.Item
                            key={year + 'net'}
                            label={year ===  years[0] ?
                                t("EcapModule.lbYears")
                                : null}
                            >
                            <Row gutter={12} className="flex-1" >
                                <Col span={12} style={{ display: 'inline-flex', alignItems: 'center'}} className="center year-center">
                                    <div>{year}</div>
                                </Col>

                                <Col span={12}>
                                    <Form.Item
                                        rules={[
                                            { required: true, message: "" }
                                        ]}
                                        name={[year, "value"]}
                                    >
                                        <AmountInput />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form.Item>
                        ))}                          
                    </div>
                </div>

                <Row gutter={8}>
                    <Col span={12}>
                        <Button type="default" onClick={props.goback} block shape="round">
                            {t("Onboarding.btnGoback")}
                        </Button>
                    </Col>
                    <Col span={12}>
                        <Button htmlType="submit" type="primary" shape="round" block>
                            {
                                t("RapmReport.btnNext")
                            }
                        </Button>
                    </Col>
                </Row>


            </Form>

        </div>
    )
}

export default ORInput;